import Model from "@/lib/model/model";
import request from "@/lib/request/request";

export class AIAnswerComponent extends Model {
  public static get(params = {}) {
    const defaultParams = {
      pageNum: 1,
      pageSize: 500,
      qaIdList: [],
      searchText: "",
      isDisabled: 2 // 已启用的
    };
    return request
      .postInterviewApi("hr/intelligentQa/list", {
        ...defaultParams,
        ...params
      })
      .then(res => {
        return res.data.data;
      });
  }
}
